import React, { useState } from "react";
import Topbar from "../Topbar/Topbar";
import ProfileNavBar from "../ProfileNavbar";
import { Outlet } from "react-router-dom";
import { knf_logo, logo } from "../../assets/imgs";

const Layout = () => {
  const givenuser = JSON.parse(localStorage.getItem("loginData"));
  const [roleText, setRoleText] = useState("");
  return (
    <div className="">
      <Topbar roleText={roleText} setRoleText={setRoleText} />
      <div className="dashboard">
        <ProfileNavBar setRoleText={setRoleText} />
        <div className="dashRightViews">
          <Outlet />
          <a
            href="https://www.knfepl.com/"
            target="_blank"
            style={{
              flexDirection: "row",
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* <div style={{ width: 75, height: 55 }}>
              <img src={knf_logo} className="knf-logo-footer" alt="" />
            </div>
            <p style={{ fontSize: 20, color: "#852e59" }}>KNF ENTERPRISES</p> */}{" "}
            <div
              className="d-flex align-items-center justify-content-center gap-2 flex-wrap"
              style={{
                padding: "10px 16px",
                borderRadius: "12px",
                background: "#fff8fc",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                width: "fit-content",
                margin: "auto",
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "#666",
                }}
              >
                Powered By
              </p>

              <div
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: "50%",
                  overflow: "hidden",
                  background: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                }}
              >
                <img
                  src={knf_logo}
                  alt="KNF Logo"
                  style={{
                    width: "80%",
                    height: "80%",
                    objectFit: "contain",
                  }}
                />
              </div>

              <p
                style={{
                  margin: 0,
                  fontSize: "13px",
                  fontWeight: 500,
                  letterSpacing: "0.5px",
                  color: "#852e59",
                }}
              >
                KNF ENTERPRISES
              </p>
            </div>
          </a>
        </div>
      </div>
      {/* {givenuser?.type !== "admin" && (
        <footer className="text-center py-2 small d-flex justify-content-center align-items-center gap-2">
          © {new Date().getFullYear()} Powered by
          <img
            src={roleText == "knf" ? logo : knf_logo}
            alt="Sim Lian"
            height="20"
          />
        </footer>
      )} */}
    </div>
  );
};

export default Layout;
